import React from 'react';

import { WarningTwoTone as AntdWarningIcon } from '@ant-design/icons/lib/icons';
import { Tooltip as AntdTooltip } from 'antd';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import { makeReadable } from 'utils/makeReadable';

import './FaussePlaqueFieldDisplay.less';

interface FaussePlaqueProps {
  immatriculation: string | null;
  immatriculationVisible: string | null;
}

const FaussePlaqueFieldDisplay = (
  props: FaussePlaqueProps,
): React.ReactElement => {
  if (!props.immatriculationVisible) {
    return <></>;
  }

  const immatriculation = makeReadable(props.immatriculation);

  return (
    <FieldDisplay
      key="fausse_plaque"
      label={
        <div>
          <AntdTooltip
            title={
              <div className={'immatriculationTooltipTitle'}>
                {`Le véritable numéro d'immatriculation de ce véhicule est : ${immatriculation}.`}
              </div>
            }
          >
            <AntdWarningIcon twoToneColor="#FF6600" className="WarningSign" />
          </AntdTooltip>
          <span>Fausse Plaque</span>
        </div>
      }
      value={props.immatriculationVisible}
      labelClass="labelAdmin"
    />
  );
};

export default FaussePlaqueFieldDisplay;
